import { AdminTopbar } from "@/components/admin/AdminLayout";
import { ModulePanel, DataTable } from "@/components/admin/AdminPrimitives";
import { TRENDING_NARRATIVES } from "@/lib/mock-data";
import { useI18n } from "@/lib/i18n";

function Disinformation() {
  const { t } = useI18n();
  return (
    <>
      <AdminTopbar title={t("admin.disinfo.title")} subtitle={t("admin.disinfo.subtitle")} />
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        <ModulePanel title={t("admin.disinfo.tracked")}>
          <DataTable
            columns={[t("admin.common.col.claim"), "Plateformes", "Risque", t("admin.common.col.status"), "Action"]}
            rows={TRENDING_NARRATIVES.map((n) => [
              <span className="font-medium text-foreground">{n.claim}</span>,
              <span className="text-xs">{n.platforms.join(", ")}</span>,
              <span className={`text-xs font-bold uppercase ${n.risk === "high" ? "text-alert" : n.risk === "medium" ? "text-verdict-misleading" : "text-muted-foreground"}`}>{n.risk}</span>,
              <span className="text-xs uppercase tracking-wider">{n.status}</span>,
              <button className="rounded-md bg-foreground px-2.5 py-1 text-[10px] font-semibold text-background">{t("admin.disinfo.response")}</button>,
            ])}
          />
        </ModulePanel>
      </div>
    </>
  );
}

export default Disinformation;
